import React from 'react';
import ResumeDownload from './ResumeDownload';

export interface ExperienceProps {}

const Experience: React.FC<ExperienceProps> = (props) => {
    return (
        <div className="site-page-content">
            <ResumeDownload />
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Percorso Formativo</h1>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Grazie al percorso scolastico ho accumulato oltre 1000 ore tra stage e apprendistato,
                    conseguito 2 diplomi e una qualifica. Questa formazione intensiva mi ha permesso di
                    acquisire competenze tecniche e professionali che hanno costituito le fondamenta per
                    la creazione di STUDIO MISMO.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>STUDIO MISMO</h1>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    La nascita di STUDIO MISMO rappresenta il culmine di un percorso di crescita personale
                    e professionale. Dopo aver completato la formazione e accumulato esperienza pratica
                    attraverso stage e apprendistato, ho sentito l'esigenza di creare uno spazio proprio
                    dove poter esprimere liberamente la mia visione creativa e tecnica.
                </p>
                <br />
                <p>
                    STUDIO MISMO nasce dall'idea di unire competenze tecniche acquisite durante gli anni
                    di studio con una passione autentica per il design e l'innovazione. Lo studio si
                    propone come un laboratorio creativo dove ogni progetto viene curato nei minimi
                    dettagli, dalla concezione iniziale fino alla realizzazione finale, mantenendo sempre
                    un equilibrio tra estetica e funzionalità.
                </p>
                <br />
                <p>
                    Questo nuovo capitolo professionale rappresenta non solo un traguardo, ma anche
                    l'inizio di un percorso dedicato alla creazione di esperienze digitali uniche e
                    significative, mettendo al centro la qualità, l'attenzione al dettaglio e
                    l'innovazione continua.
                </p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    header: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
    },
    skillRow: {
        flex: 1,
        justifyContent: 'space-between',
    },
    skillName: {
        minWidth: 56,
    },
    skill: {
        flex: 1,
        padding: 8,
        alignItems: 'center',
    },
    progressBar: {
        flex: 1,
        background: 'red',
        marginLeft: 8,
        height: 8,
    },
    hoverLogo: {
        height: 32,
        marginBottom: 16,
    },
    headerContainer: {
        alignItems: 'flex-end',
        width: '100%',
        justifyContent: 'center',
    },
    hoverText: {
        marginBottom: 8,
    },
    indent: {
        marginLeft: 24,
    },
    headerRow: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

export default Experience;
